/**
 * @license Copyright (c) Microsoft Corporation.  All rights reserved.
 */
var CustomerVoiceEntity = /** @class */ (function () {
    function CustomerVoiceEntity() {
    }
    CustomerVoiceEntity.EntitySetName = "msfp_surveies";
    CustomerVoiceEntity.FieldName_SurveyIdentifier = "msfp_surveyid";
    CustomerVoiceEntity.FieldName_SourceSurveyIdentifier = "msfp_sourcesurveyidentifier";
    CustomerVoiceEntity.FieldName_Name = "msfp_name";
    CustomerVoiceEntity.FieldName_AcceptAnonymousResponses = "msfp_acceptanonymousresponses";
    CustomerVoiceEntity.FieldName_SurveyUrl = "msfp_surveyurl";
    CustomerVoiceEntity.FieldName_AnonymousUrl = "msfp_anonymousurl";
    return CustomerVoiceEntity;
}());
export { CustomerVoiceEntity };
